<template>
  <ErrorModal />
  <q-dialog v-model="showEditUser" persistent class="edit-user-dialog">
    <q-card style="min-width: 300px">
      <q-card-section>
        <div>
          <span>
            <i class="las la-2x la-edit la-fw"></i>
              Bewerk gebruiker
          </span>
        </div>
      </q-card-section>

      <q-separator />

      <q-card-section class="q-pt-none">
        <div class="row justify-around">
          <q-input
            class="q-pa-md"
            v-model="email"
            filled
            type="email"
            label="Email"
            stack-label
            :rules="[isValidEmail, requiredFieldRule]"
          >
            <template v-slot:prepend>
              <q-icon name="mail" small/>
            </template>
          </q-input>
        </div>

        <div class="row justify-around">
          <q-input
            class="q-pa-md"
            dense
            v-model="firstName"
            label="Voornaam"
            stack-label
            :rules="requiredFieldRule"
          />
          <q-input
            class="q-pa-md"
            dense
            v-model="lastName"
            label="Achternaam"
            stack-label
            :rules="requiredFieldRule"
          />
        </div>
      </q-card-section>

      <q-separator />

      <q-card-actions align="around">
        <q-btn           
          class="save-btn-q"
          no-caps
          flat
          label="Opslaan" 
          @click="editUser()"
        />
        <q-btn 
          no-caps
          flat
          class="cancel-btn"
          outline
          label="Annuleren" 
          @click="disableEditUser()" 
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { onMounted, computed } from 'vue';
import store from '../../store/index.js';
import ErrorModal from './ErrorModal.vue';
import UserService from '../../services/userprofile.service';

export default {
  components: {
    ErrorModal,
  },
  setup() {

    const showEditUser = computed({
      get: () => store.state.user.showEditUserDialog,
    });

    const userId = computed({
      get: () => store.state.user.selectedPersonForEdit.userId,
    });
    const email = computed({
      get: () => store.state.user.selectedPersonForEdit.email,
      set: (value) =>
        store.commit('user/updateSelectedUserEmail', value)
    });
    const firstName = computed({
      get: () => store.state.user.selectedPersonForEdit.firstName,
      set: (value) =>
        store.commit('user/updateSelectedUserFirstName', value)
    });
    const lastName = computed({
      get: () => store.state.user.selectedPersonForEdit.lastName,
      set: (value) =>
        store.commit('user/updateSelectedUserLastName', value)
    });

    const updatedUser = {
      id: userId,
      email: email,
      firstName: firstName,
      lastName: lastName,
    }

    onMounted(() => {
    });

    const disableEditUser = () => {
      store.commit('user/disableEditUser');
    };

    const editUser = async () => {
      await UserService.editFrontOfficeUser(updatedUser);
      disableEditUser();
    };

    return {
      userId,
      email,
      firstName,
      lastName,
      showEditUser,
      disableEditUser,
      editUser,
      updatedUser,
      requiredFieldRule: [
        (val) => (val && val.length > 0) || 'Veld is verplicht!',
      ],
      isValidEmail(val) {
        const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
        return emailPattern.test(val) || 'Invalid email';
      },
    };
  },
};
</script>
